import _ from "lodash";
import { Permission, Role } from "../../../api/schema";
import { UserLanguage } from "../../../lang/lang";

interface RoleItemProps {
  role: Role;
}

interface RolePermissionsProps {
  permissions: Permission[];
}

interface PermissionItemProps {
  permission: Permission;
}

const PermissionItem = ({ permission }: PermissionItemProps) => {
  const { node } = permission;
  const t = _.get(UserLanguage().data.permissions, node);
  if (t)
    return (
      <li key={"p_" + permission.id}>
        {t} <span style={{ color: "lightgray" }}>({permission.node})</span>
      </li>
    );
  return <li key={"p_" + permission.id}>{permission.node}</li>;
};

const RolePermissions = ({ permissions }: RolePermissionsProps) =>
  permissions.length > 0 ? (
    <ol>
      {_.map(permissions, (p) => (
        <PermissionItem permission={p} />
      ))}
    </ol>
  ) : (
    <>{UserLanguage().data.none}</>
  );

const RoleItem = ({ role }: RoleItemProps) => (
  <>
    <li>{role.name}</li>
    <li>
      <RolePermissions permissions={role.permissions} />
    </li>
  </>
);

export const Roles = (props: { roles?: Role[] }) => {
  if (!props.roles) return null;

  if (props.roles.length === 0)
    return (
      <ul>
        <li style={{ color: "lightgray" }}>{UserLanguage().data.none}</li>
      </ul>
    );

  return (
    <ol>
      {_.map(props.roles, (role) => (
        <RoleItem role={role} />
      ))}
    </ol>
  );
};

export const Permissions = (props: { permissions?: Permission[] }) => {
  if (!props.permissions) return null;

  if (props.permissions.length === 0)
    return (
      <ul>
        <li style={{ color: "lightgray" }}>{UserLanguage().data.none}</li>
      </ul>
    );

  return (
    <ol>
      {_.map(props.permissions, (permission) => (
        <PermissionItem permission={permission} />
      ))}
    </ol>
  );
};
